import Avatar from '../img/avatar.png'

const Content = {
  navbar: {
    social_links: [
      {
        name: "Linkedin",
        href: "https://www.linkedin.com/in/severidade/",
      },
      {
        name: "GitHub",
        href: "https://github.com/severidade",
      },
      {
        name: "Codpen",
        href: "https://codepen.io/severidade",
      },
      {
        name: "Behance",
        href: "https://www.behance.net/severidade"
      },
    ],
  },
  about: {
    img: Avatar,
    description:"<h3>Olá, meu nome é Marco Severo, agradeço a sua visita.</h3><p><strong>Graduado em Publicidade pela UFMG (2001)</strong>, atuo por mais de 20 anos como <strong>Designer Gráfico</strong> especializado em produtos impressos e há um ano migrei para a área de tecnologia, como <strong>UI/UX</strong> com foco em desenvolvimento de interfaces. Meu interesse pela programação e sua capacidade de transformar conceitos visuais em experiências interativas me levou a explorar o mundo do <strong>desenvolvimento front-end</strong>, o que me permite unir minha experiência em design com habilidades de codificação para criar interfaces envolventes e intuitivas. A <strong>união entre design e programação</strong> tornou-se meu diferencial, permitindo-me oferecer soluções inovadoras e altamente funcionais aos meus clientes.</p>",
  },
  skills: {
    front_end: "HTML5, CSS3, Javascript, React, Redux e Testes Automatizados com RTL.",
    back_end: "MySQL, MongoDB, Node.JS",
    others: "UI/UX Design, Git/Github, Figma, Photoshop, Ilustrator, Slack, Desenvolvimento ágil (Notion, Trello)"
  }
}

export default Content; 